import * as api from './PatientApi';
import { messages } from '../../lang/en';
import { getClinicId, getNamespace } from '../../utils/storage';
import * as type from './PatientType';
// const reportFormat = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const setSelectedPatient = (selectedPatient) => (dispatch) => {
    dispatch({
        type: type.SET_SELECTED_PATIENT,
        payload: selectedPatient
    });
};
export const getPatient =
    (patientId, service = api.getPatientDetail) =>
    async (dispatch) => {
        const clinicId = getClinicId();
        const namespace = getNamespace();
        dispatch({
            type: type.GET_PATIENT.REQUEST
        });
        return await service(patientId, namespace, clinicId).then((response) => {
            dispatch({
                type: type.GET_PATIENT.SUCCESS,
                payload: response.data
            });
        });
    };
export const deletePatient =
    (patientId, service = api.deletePatient) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(patientId, namespace).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: type.DELETE_PATIENT,
                    payload: patientId
                });
            }
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: messages.postActionAlert.patientDeleted,
                    status: response.status
                }
            });
            return response;
        });
    };
export const editPatient =
    (patientId, patient, service = api.editPatient) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(patientId, patient, namespace).then((response) => {
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: messages.postActionAlert.patientEdited,
                    status: response.status
                }
            });
            dispatch({
                type: type.GET_PATIENT,
                payload: response.data
            });
            dispatch({
                type: type.REPLACE_EDITED_PATIENT,
                payload: response.data
            });
        });
    };
export const getPatients =
    (params, isHintSearch = false, service = api.getPatients) =>
    async (dispatch) => {
        dispatch({
            type: type.GET_PATIENTS.REQUEST
        });
        const namespace = getNamespace();
        return await service(namespace, params, isHintSearch)?.then((response) => {
            dispatch({
                type: type.GET_PATIENTS.SUCCESS,
                payload: response.data.patients
            });
        });
    };
export const clearPatients = () => (dispatch) => {
    dispatch({
        type: type.GET_PATIENTS,
        payload: []
    });
};
export const createPatient =
    (patient, service = api.createPatient) =>
    async (dispatch) => {
        return await service(patient).then((response) => {
            dispatch({
                type: 'ADD_MESSAGE',
                patient: response.data,
                payload: {
                    text: messages.postActionAlert.patientSubmitted,
                    status: response.status
                }
            });
            dispatch(setSelectedPatient(response.data));
            return response;
        });
    };
export const loadMorePatients =
    (params, namespace, service = api.getPatients) =>
    async (dispatch) => {
        if (!namespace) {
            namespace = getNamespace();
        }
        if (params.offset === 0) {
            dispatch({
                type: type.LOAD_PATIENTS.REQUEST
            });
        }
        dispatch({
            type: type.PENDING_LOAD_MORE_PATIENTS,
            payload: true
        });
        return await service(namespace, params)?.then((response) => {
            dispatch({
                type: type.LOAD_PATIENTS.SUCCESS,
                payload: response.data.patients,
                params,
                total: response.data.total
                // limit
            });
        });
    };
// export const getAllPatientsReport = (namespace) => async (dispatch) => {
//     if (!namespace) {
//         namespace = getNamespace();
//     }
//     return await api.getAllPatientsReport(namespace).then((response) => {
//         const url = URL.createObjectURL(
//             new Blob([response.data], {
//                 type: reportFormat
//             })
//         );
//         dispatch({
//             type: 'GET_PATIENT_REPORT',
//             payload: url
//         });
//     });
// };

export const listOfSelectPatients = (data) => (dispatch) => {
    dispatch({
        type: type.LIST_OF_SELECT_PATIENTS,
        payload: data
    });
};
export const addPatientToList = (data) => (dispatch) => {
    dispatch({
        type: type.ADD_PATIENT_TO_LIST,
        payload: data
    });
};

export const deleteSelectedPatient = (id) => (dispatch) => {
    dispatch({
        type: type.DELETE_SELECTED_PATIENT,
        payload: id
    });
};
export const delAllSelectedPatients = () => (dispatch) => {
    dispatch({
        type: type.DEL_ALL_SELECTED_PATIENT
    });
};
export const summonPatient =
    (patientId, clinicId, service = api.summonPatient) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(patientId, clinicId, namespace).then((response) => {
            if (response.status >= 200 && response.status <= 300) {
                dispatch({
                    type: 'ADD_MESSAGE',
                    patient: response.data,
                    payload: {
                        text: 'patient was successfully added to the currently clinic',
                        status: 200
                    }
                });
                dispatch({
                    type: type.SUMMON_PATIENT,
                    payload: response.data
                });
            }
            return response;
        });
    };
